import * as constants from './constants';

export const brandClick=()=>({
    type:constants.BRAND_CLICK
})
export const productClick=()=>({
    type:constants.PRODUCT_CLICK
})
export const newsClick=()=>({
    type:constants.NEWS_CLICK
})
export const exhibitionClick=()=>({
    type:constants.EXHIBITION_CLICK
})
export const postClick=()=>({
    type:constants.POST_CLICK
})
export const evaluationClick=()=>({
    type:constants.EVALUATION_CLICK
})
export const auditionClick=()=>({
    type:constants.AUDITION_CLICK
})
export const myCollectClick=()=>({
    type:constants.MY_COLLECT_CLICK
})
export const myCommunityClick=()=>({
    type:constants.MY_COMMUNITY_CLICK
})
export const myEvaluationClick=()=>({
    type:constants.MY_EVALUATION_CLICK
})
export const myAuditionClick=()=>({
    type:constants.MY_AUDITION_CLICK
})
export const myCommunityPostClick=()=>({
    type:constants.MY_COMMUNITY_POST_CLICK
})
export const myCommunityCommentClick=()=>({
    type:constants.MY_COMMUNITY_COMMENT_CLICK
})
export const myCommunityLikeClick=()=>({
    type:constants.MY_COMMUNITY_LIKE_CLICK
})
export const myFocusClick=()=>({
    type:constants.MY_FOCUS_CLICK
})
export const myFansClick=()=>({
    type:constants.MY_FANS_CLICK
})
export const myGroupClick=()=>({
    type:constants.MY_GROUP_CLICK
})
export const myEvaluationPostClick=()=>({
    type:constants.MY_EVALUATION_POST_CLICK
})
export const myEvaluationCommentClick=()=>({
    type:constants.MY_EVALUATION_COMMENT_CLICK
})
export const myEvaluationLikeClick=()=>({
    type:constants.MY_EVALUATION_LIKE_CLICK
})
export const myAuditionPostClick=()=>({
    type:constants.MY_AUDITION_POST_CLICK
})
export const myAuditionLikeClick=()=>({
    type:constants.MY_AUDITION_LIKE_CLICK
})
export const myAuditionlikeClick=()=>({
    type:constants.MY_AUDITION_LIKE_CLICK
})
export const componentUserClick=()=>({
    type:constants.COMPONENT_USER_CLICK
})
export const focusAndFansClick=()=>({
    type:constants.FOCUS_AND_FANS_CLICK
})